import { assertResolvedAtsNotHttpError } from '@/api/ats/atsEnvelope';
import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

export interface InterviewerPoolUser {
  id: number;
  name: string;
  avatar_url?: string;
  email: string;
}

export interface InterviewerPoolDetail {
  id: number;
  name: string;
  category: 'ats_interviewer_pool';
  users: InterviewerPoolUser[];
}

interface GetInterviewerPoolApiResponse {
  data: InterviewerPoolDetail;
  errors: string[];
}

const toPoolId = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

export const useGetInterviewerPool = ({
  id: rawId,
}: {
  id: number | string | undefined | null;
}) => {
  const poolId = toPoolId(rawId);

  const query = useQuery<GetInterviewerPoolApiResponse, Error>({
    queryKey: ['interviewer-pool', poolId],
    queryFn: async () => {
      const res = await http.get<GetInterviewerPoolApiResponse>(
        `user_groups/${poolId}`
      );
      assertResolvedAtsNotHttpError(res);
      return res as unknown as GetInterviewerPoolApiResponse;
    },
    staleTime: 0,
    enabled: poolId !== undefined,
  });

  const interviewerPool = query.data?.data;
  const uiError = query.data?.errors ?? [];

  return { interviewerPool, uiError, ...query };
};
